import {
  recordCharged,
  setUserProperties,
  trackEvent as trackCleverTapEvent,
} from './clevertapService';

/**
 * Track a custom event to CleverTap.
 * @param {string} eventName
 * @param {Record<string, unknown>} [properties]
 */
export function trackAnalyticsEvent(eventName, properties) {
  trackCleverTapEvent(eventName, stripNulls(cleanProperties(properties)));
}

/**
 * CleverTap Charged event for revenue.
 * Uses razorpay_payment_id as Charged ID for deduplication.
 */
export function trackRevenuePurchase({
  transactionId,
  value,
  currency = 'INR',
  items = [],
  paymentMode,
}) {
  if (!transactionId) return;

  const amount = Number(value) || 0;
  const chargedItems = items.map((item) => ({
    Category: item.item_category || item.category || '',
    'Product name': item.item_name || item.name || '',
    Price: Number(item.price) || 0,
    Quantity: Number(item.quantity) || 1,
  }));

  recordCharged({
    Amount: amount,
    Currency: currency,
    'Charged ID': transactionId,
    'Payment mode': paymentMode || 'razorpay',
    Items: chargedItems,
  });
}

export function updateAnalyticsUserProperties(properties = {}) {
  setUserProperties(properties);
}

function cleanProperties(properties) {
  if (!properties || typeof properties !== 'object') return undefined;

  const cleaned = {};
  Object.entries(properties).forEach(([key, value]) => {
    if (value === undefined) return;
    cleaned[key] = value;
  });
  return cleaned;
}

function stripNulls(properties) {
  if (!properties || typeof properties !== 'object') return properties;

  const cleaned = {};
  Object.entries(properties).forEach(([key, value]) => {
    if (value == null) return;
    cleaned[key] = value;
  });
  return cleaned;
}
